export function setAppBadge(): void {
    if (typeof self.navigator?.setAppBadge === 'function') {
        navigator.setAppBadge()?.catch(() => {
            // Ignore the error
        });
    }
}

export function clearAppBadge(): void {
    if (typeof self.navigator?.clearAppBadge === 'function') {
        navigator.clearAppBadge()?.catch(() => {
            // Ignore the error
        });
    }
}
